import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { NotificationFilterEnum } from '../enums/notification';
import {
  NotificationPreferenceResponseSchema,
  NotificationPreferenceUpdate,
  NotificationResponseSchema,
} from '../models/notification';
import { ConfigService } from '../services/config';
import { parseResponse } from './helper';

const NOTIFICATIONS_PATH = '/shared/notification';
const NOTIFICATIONS_PREFERENCE_PATH = '/shared/notification-preference';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  // services
  #http = inject(HttpClient);
  configService = inject(ConfigService);
  getNotifications(
    filter: NotificationFilterEnum = NotificationFilterEnum.ALL,
    limit = 100,
  ) {
    const endpoint = `${this.configService.baseApi}${NOTIFICATIONS_PATH}`;
    return this.#http
      .get<unknown>(endpoint, {
        params: {
          is_read: `${filter}`,
          page_size: `${limit}`,
        },
      })
      .pipe(parseResponse(NotificationResponseSchema));
  }

  markRead(payload: { ids: string[] }) {
    const endpoint = `${this.configService.baseApi}${NOTIFICATIONS_PATH}`;
    return this.#http.patch(endpoint, payload);
  }

  getNotificationPreferences(pageSize: number, page: number) {
    const endpoint = `${this.configService.baseApi}${NOTIFICATIONS_PREFERENCE_PATH}`;
    return this.#http
      .get<unknown>(endpoint, {
        params: {
          page_size: pageSize,
          page,
        },
      })
      .pipe(parseResponse(NotificationPreferenceResponseSchema));
  }
  updatePreference(payload: NotificationPreferenceUpdate) {
    const endpoint = `${this.configService.baseApi}${NOTIFICATIONS_PREFERENCE_PATH}`;
    return this.#http.patch(endpoint, payload);
  }

  registerPushToken(token: string) {
    const endpoint = `${this.configService.baseApi}${NOTIFICATIONS_PREFERENCE_PATH}`;
    return this.#http.patch(endpoint, { push_token: token });
  }
}
